import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Indicatore di caricamento. Decorativo dentro un pulsante (lo stato è già su `aria-busy`);
 * con `label` diventa uno stato annunciato.
 */
@Component({
  selector: 'bs-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex items-center gap-2' },
  template: `
    <svg
      class="animate-spin"
      [attr.width]="size()"
      [attr.height]="size()"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        stroke-opacity="0.25"
        stroke-width="2.5"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
      />
    </svg>
    @if (label(); as text) {
      <span role="status" class="text-sm text-stone-600 dark:text-stone-300">{{ text }}</span>
    }
  `,
})
export class SpinnerComponent {
  readonly size = input(20);
  readonly label = input<string | null>(null);
}
